var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"control"},[_c('markdown-editor',{attrs:{"placeholder":_vm.placeholder},model:{value:(_vm.value_),callback:function ($$v) {_vm.value_=$$v},expression:"value_"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }